import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ForbiddenComponent} from '@Common/forbidden/forbidden.component';
import {AccueilComponent} from "./accueil/accueil.component";
import {AuthenticatedGuardService, GestionnaireGuardService} from "app/suaps/common/services/guards/guards.service";


const appRoutes: Routes = [
  {
    path: '',
    children: [
      { path: '', component: AccueilComponent },
      // { path: 'planning/:id', component: AccueilPlanningComponent, canActivate: [AuthenticatedGuardService] },
      { path: 'planning/:id', component: AccueilComponent },
      { path: '**', component: AccueilComponent },
    ]
  },
  {path: 'forbidden', component: ForbiddenComponent},
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { })
  ],
  exports: [
    RouterModule,
  ]
})
export class AppRoutingModule {
}
